import '../GlowSubWidgets.css';
import React from "react";

function StartingWork(props) {

    return (
        <div>
            <p> starting work </p>
        </div>
    )
}

export default StartingWork;